import { ProductViewRecordService } from '@/services/api/hl-proxy/product-view'
import { ProductDetailViewEvent } from '@/usecases/event-bus-for-third-party/events/product-detail'

/**
 * 商品詳細の表示をホテラバアプリBFF に記録する(LIVE で紹介した商品の効果測定に使われる)。
 *
 * 記録するのは初期表示されているFKU(カラー)で、カート追加UIでカラーを切り替えても追加では記録しない。
 * イベントのFKUの並び順に依存しないよう、初期表示のFKUは1件に絞らず該当するすべてを記録する。
 * @see https://github.com/Everforth/growthpalette-front/issues/9289#issuecomment-5631010459
 */
export function createProductDetailViewHandlerForHotelloversAppBFF(
  service: ProductViewRecordService
): (event: ProductDetailViewEvent) => void {
  return (event) => {
    // 商品詳細の初期化を待たせないため結果は待たない。記録の失敗はservice側で握る
    event.fku
      .filter(fku => fku.isInitialDisplayed)
      .forEach(fku => service.record(fku.id))
  }
}

export const handleProductDetailViewEventForHotelloversAppBFF =
  createProductDetailViewHandlerForHotelloversAppBFF(new ProductViewRecordService())
